import { Button } from '@devfolioco/genesis';
import { connect } from 'react-redux';
import Countdown from 'react-countdown-now';
import React from 'react';

import { resendEmailOTP } from '../../actions/user';

class ResendButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      disabled: true,
    };
  }

  onTimeOut = () => {
    this.setState({ disabled: false });
  };

  sendCode = () => {
    const { dispatchSendEmailOTP, email } = this.props;
    dispatchSendEmailOTP(email);
  };

  resendCode = () => {
    this.setState({ disabled: true }, () => this.sendCode());
  };

  render() {
    const { disabled } = this.state;

    const enableButtonAtTime = Date.now() + 60000;

    return (
      <Button
        type="button"
        appearance="secondary"
        disabled={disabled}
        stretch
        onClick={this.resendCode}
        style={{
          marginTop: 8,
        }}
      >
        Resend code{' '}
        {disabled && (
          <Countdown
            date={enableButtonAtTime}
            renderer={({ seconds, completed }) => {
              if (completed) {
                this.onTimeOut();
              }

              if (seconds === 0) {
                return null;
              }

              return <span>&nbsp;({seconds}s)</span>;
            }}
          />
        )}
      </Button>
    );
  }
}

const mapStateToProps = ({ authentication }) => ({
  username: authentication.username,
});

const mapDispatchToProps = dispatch => ({
  dispatchSendEmailOTP: authParam => {
    dispatch(resendEmailOTP(authParam));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ResendButton);
